import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import './InfoPage.css';

const termsBody = {
  en: `General Provisions

1. LLC "Sifrifana" is a company registered in accordance with the legislation of Georgia.
Name: LLC Sifrifana

Identification number: 445586553
Legal address: Georgia, Georgia, Batumi, Gonio settlement
Physical address: 44 Zh. Shartava St.
Email: infosifrifana@gmail.com

2. A user's entry to the Sifrifana website and ordering of the offered service means that the user has expressed consent to follow the rules of use and the terms and conditions set out in this agreement.

Subject of the Agreement

1. The subject of this agreement is any product offered on any Sifrifana platform and the service of delivering this product to the place desired by the user, in exchange for which the user pays a predefined amount by bank card or in cash.

Terms and Obligations for Using the Website

1. In order to use the services of sifrifana.ge, the user agrees to provide truthful, accurate, and complete information required during registration and while placing an order.

2. If the user provides incorrect information, or if LLC Sifrifana has serious grounds to suspect that the information provided by the user is incorrect, incomplete, or inaccurate, it has the right to refuse to provide the service.

3. The website contains copyrighted materials, trademarks, and other materials protected by law.

4. When registering on sifrifana.ge, the user provides the following information: name, email address, phone number.

5. When placing an order, the user provides the following information: name, contact phone number, delivery address.

6. By providing personal data during registration/order placement on sifrifana.ge, the user agrees to the processing of such data, including for the purpose of informing users about services.

7. sifrifana.ge uses the user's personal data for registering the user on the website, fulfilling its obligations toward the user, and analyzing the operation of the website.

8. LLC Sifrifana has the right, with the user's consent, to send informational messages, including advertising messages, to the user's email and mobile phone. The user has the right to refuse to receive advertising and other information without explaining the reasons for refusal.

The Service Provider Is Obliged To

1. Receive and fulfill the user's order.

2. Deliver quality products to the user in accordance with high hygiene standards.

3. Protect the user's personal data in accordance with the legislation of Georgia.

Delivery Terms

The delivery period is determined as 2 business days from receipt of the order. Depending on the complexity of the address, the delivery period may be extended up to 5 business days.

Return Terms

The user has the right to submit a request to return the purchased item within 14 calendar days from receiving the item. The period is calculated from the moment the item is transferred into the user's possession. After this period expires, the user loses the right to request the return of the item. To use this right, the user is obliged to fill out the item return form and send it to the following email address: infosifrifana@gmail.com or contact us through the Facebook page: https://www.facebook.com/sifrifanageorgia

In case of withdrawal from the agreement, the user is obliged to:

Return the goods to the seller or to a third party designated by the seller immediately after sending the notice of withdrawal from the agreement, but no later than within 7 calendar days;

Bear the direct costs related to returning the goods.

The user is obliged to return the item in full together with all accompanying documents.

The seller is obliged, within 14 calendar days from receiving the notice of return of the item, to refund the amount paid by the user. The seller has the right to refuse the refund until it receives the goods back or receives from the user a document confirming shipment of the goods, whichever occurs earlier.

The refund will be made using the same payment method used by the user, except where the user agrees to use another payment method.

The user's withdrawal from a distance contract automatically causes withdrawal from any related agreement and restoration of the original condition.

As a result of withdrawal from the agreement, the obligations undertaken by the parties under the distance contract are terminated, and everything received by the parties through its performance shall be returned to them. Exception related to withdrawal from the agreement without indicating any grounds: with the user's consent, the seller may replace the product instead of refunding the amount.

Warranty Terms

6. Statutory Warranty

* If the goods are defective, the user has the right to request that the seller remedy the defect (free repair or replacement of the goods, price reduction) or withdraw from the agreement.

* Repair and replacement of the goods are the user's first-order rights. The user has the right to request free repair or replacement of the goods from the seller, except where this is impossible due to the nature of the goods or requires disproportionate or unreasonably large costs.

* The goods must be repaired or replaced within a reasonable period. The repair period for an item is 30 days, and the replacement period is 10 days, in a way that does not create significant inconvenience for the user, considering the nature of the goods and the purpose for which the user purchased them.

* Free repair or replacement of the goods includes all costs borne by the seller, including postage, labor, and materials required to ensure the goods comply with the terms provided by the agreement.

* The user has the right to request a reduction of the goods' price or withdraw from the agreement if one of the following conditions exists:

a) repair or replacement of the goods is impossible;

b) the seller did not repair or replace the goods within a reasonable period and the user lost interest in performance of the agreement;

c) repair or replacement of the goods by the seller would create significant inconvenience for the user.

* In case of withdrawal from the agreement, the user has the right to claim compensation for damage caused by non-performance of the agreement in accordance with the rules established by the legislation of Georgia.

* The user does not have the right to withdraw from the agreement if the defect of the goods is insignificant.

* When determining whether the cost is disproportionate or unreasonably large, the following conditions will be taken into account:

a) the price of the goods or service if it complied with the terms provided by the agreement;

b) the degree of non-compliance of the goods or service with the terms provided by the agreement;

c) the alternative possibility of remedying the defect of the goods without creating inconvenience for the user.

* The user has the right to exercise the above rights if the defect of the goods is discovered within 2 years from transfer of the goods to the user.

* If the user discovers a defect in the goods within 6 months from receiving possession of the goods, until the contrary is proven it shall be presumed that the defect existed at the time of delivery, if this is possible considering the nature of the goods or the nature of the defect. In this case, the burden of proof lies with the seller. If the user discovers a defect in the goods after 6 months from receiving possession of the goods, the burden of proving that the defect existed at the time of delivery lies with the user.

5. Force Majeure

* Neither party shall be liable for full or partial non-performance of an undertaken obligation if the non-performance was caused by natural and technological disasters, fire, military actions, or governmental decisions, provided that these events began or developed after the order was purchased.

* If any of the listed circumstances directly affects the deadline for a party's performance of obligations determined by these consumer terms and conditions, this deadline shall be extended according to the duration of the force majeure circumstance.

* The party affected by a force majeure circumstance is obliged to notify the other party about such circumstance, its possible duration, and its termination.

* The facts reflected in the notice must be confirmed by the relevant regional trade, industrial, or other competent authority.

* Failure to notify or delayed notification deprives the party of the right to use the above force majeure events as grounds for release from liability.`,
  ka: `ზოგადი დებულებები

1. შპს “სიფრიფანა" წარმოადგენს საქართველოს კანონმდებლობის შესაბამისად რეგისტრირებულ კომპანიას.
დასახელება: შპს სიფრიფანა

საიდენტიფიკაციო ნომერი: 445586553
იურიდიული მისამართი: საქართველო,საქართველო, ბათუმი, გონიოს დასახლება
ფიზიკური მისამართი: ჟ.შარტავას 44
ელ ფოსტა: infosifrifana@gmail.com

2. მომხმარებლის მიერ “სიფრიფანას“ვებ-გვერდზე შესვლა და შემოთავაზებული სერვისის შეკვეთა გულისხმობს, რომ მან გამოხატა თანხმობა შეასრულოს წინამდებარე ხელშეკრულებით გათვალისწინებული მოხმარების წესები და პირობები.

ხელშეკრულების საგანი

1. წინამდებარე ხელშეკრულების საგანს წარმოადგენს სიფრიფანას ნებისმიერ პლატფორმაზე შემოთავაზებული პროდუქტი და ამ პროდუქტის მომხმარებლისთვის სასურველ ადგილზე მიტანის მომსახურება, რის სანაცვლოდაც მომხმარებელი იხდის წინასწარ განსაზღვრულ თანხას საბანკო ბარათით ან ნაღდი ანგარიშსწორებით.

საიტით სარგებლობის პირობები და ვალდებულებები

1. რომ ისარგებლოს sifrifana.ge-ს მომსახურეობით, მომხმარებელი თანახმაა წარმოადგინოს, უტყუარი, ზუსტი და სრული ინფორმაცია რაც მოთხოვნილია რეგისტრაციის და შეკვეთის გაკეთების დროს.

2. თუკი მომხმარებელი წარმოადგენს არასწორ ინფორმაციას ან თუკი შ.პ.ს სიფრიფანას გააჩნია სერიოზული საფუძველი დაეჭვდეს, რომ მის მიერ წარმოდგენილი ინფორმაცია არასწორია, არასრული და უზუსტო, აქვს უფლება, უარი განუცხადოს მომსახურეობის გაწევაზე.

3. საიტი შეიცავს საავტორო უფლებით დაცულ მასალებს, სავაჭრო ნიშნებს და სხვა კანონით დაცულ მასალებს.

4. sifrifana.ge-ის საიტზე რეგისტრაციისას მომხმარებელი წარადგენს შემდეგ ინფორმაციას: სახელი, ელექტრონული ფოსტის მისამართი, ტელეფონის ნომერი.

5. შეკვეთის გაფორმებისას მომხმარებელი წარადგენს შემდეგ ინფორმაციას: სახელი, საკონტაქტო ტელეფონის ნომერი, მიწოდების მისამართი.

6. მომხმარებელი sifrifana.ge-ზე რეგისტრაციისას/დაკვეთის დროს თავისი პირადი მონაცემების წარმოდგენით ეთანხმება მათ დამუშავებას, მათ შორის თავისი მომსახურეობის შესახებ მომხმარებელთა ინფორმირების მიზნით.

7. sifrifana.ge იყენებს მომხმარებლის პირად მონაცემებს: მომხმარებლის ვებსაიტზე -ზე სარეგისტრაციოდ, მომხმარებლის მიმართ თავისი ვალდებულებების შესასრულებლად და საიტის სამუშაოს ანალიზისთვის.

8. შ.პ.ს სიფრიფანას აქვს უფლება გაგზავნოს საინფორმაციო, მათ შორის სარეკლამო შეტყობინებები მომხმარებლის ელექტრონულ ფოსტაზე და მობილურ ტელეფონზე მისი თანხმობით, მომხმარებელს უფლება აქვს უარი განაცხადოს სარეკლამო და სხვა სახის იფორმაციის მიღებაზე უარის მიზეზების განმარტების გარეშე.

მომსახურების მიმწოდებელი ვალდებულია

1. მიიღოს და შეასრულოს მომხმარებლის შეკვეთა.

2. მიაწოდოს მომხმარებელს ხარისხიანი და მაღალი ჰიგიენური სტანდარტების შესაბამისად.

3. დაიცვას მომხმარებლის პერსონალური მონაცემები საქართველოს კანონმდებლობის შესაბამისად.

მიწოდების პირობები

მიწოდების ვადა განისაზღვრება შეკვეთის მიღებიდან 2 სამუშაო დღედ. მისამართის სირთულიდან გამომდინარე შესაძლოა გაიზარდოს მიტანის ვადა 5 სამუშაო დღემდე.

დაბრუნების პირობები

მომხმარებელს უფლება აქვს ნივთის ჩაბარებიდან 14 კალენდარული დღის განმავლობაში დააფიქსიროს მოთხოვნა შეძენილი ნივთის უკან დაბრუნების თაობაზე. ვადა აითვლება მომხმარებლისთვის ნივთის მფლობელობაში გადაცემის მომენტიდან. ამ ვადის გასვლასთან ერთად, მომხმარებელი კარგავს ნივთის უკან დაბრუნების მოთხოვნის უფლებას. აღნიშნული მოთხოვნის სარგებლობისთვის მომხმარებელი ვალდებულია შეავსოს ნივთის დაბრუნების ფორმა) და გადმოგზავნოს შემდეგ ელ-ფოსტაზე: infosifrifana@gmail.com ან დაგვიკავშირდეს ფეისბუქ გვერდზე https://www.facebook.com/sifrifanageorgia

ხელშეკრულებაზე უარის თქმის შემთხვევაში მომხმარებელი ვალდებულია:

მოვაჭრეს ან მის მიერ განსაზღვრულ მესამე პირს დაუბრუნოს საქონელი ხელშეკრულებაზე უარის თქმის შესახებ შეტყობინების გაგზავნის შემდეგ დაუყოვნებლივ, მაგრამ არაუგვიანეს 7 კალენდარული დღისა;

გასწიოს საქონლის დაბრუნებასთან დაკავშირებული პირდაპირი (უშუალო) ხარჯი.

მომხმარებელი ვალდებულია სრულად დააბრუნოს ნივთი ყველა თანდართულ დოკუმენტთან ერთად.

მოვაჭრე ვალდებულია ნივთის უკან დაბრუნების შეტყობინების მიღებიდან 14 კალენდარული დღის განმავლობაში, უკან დაუბრუნოს მომხმარებელს მის მიერ გადახდილი თანხა. მოვაჭრეს უფლება აქვს, უარი თქვას თანხის დაბრუნებაზე მანამ, სანამ საქონელს არ დაიბრუნებს ან მომხმარებლისგან არ მიიღებს საქონლის გაგზავნის დამადასტურებელ დოკუმენტს, იმის მიხედვით, რომელიც უფრო ადრე განხორციელდება.

თანხის ანაზღაურება მოხდება გადახდის იმავე საშუალებებით, რომლებიც მომხმარებელმა გამოიყენა, გარდა იმ შემთხვევისა, როდესაც მომხმარებელი გადახდის სხვა საშუალების გამოყენებაზე თანხმობას განაცხადებს.

მომხმარებლის მიერ დისტანციურ ხელშეკრულებაზე უარის თქმა ავტომატურად იწვევს დაკავშირებული ხელშეკრულებიდან მის გასვლას და პირვანდელი მდგომარეობის აღდგენას.

ხელშეკრულებაზე უარის თქმის შედეგად ქარწყლდება მხარეების მიერ დისტანციური ხელშეკრულებით ნაკისრი ვალდებულებები, ხოლო ის, რაც მხარეებმა მისი შესრულებით მიიღეს, მათ უბრუნდებათ. ყოველგვარი საფუძვლის მითითების გარეშე ხელშეკრულებაზე უარის თქმასთან დაკავშირებული გამონაკლისი მოვაჭრეს შეუძლია, მომხმარებლის თანხმობით, თანხის დაბრუნების ნაცვლად, მომხმარებელს შეუცვალოს პროდუქცია.

საგარანტიო პირობები

6. კანონისმიერი გარანტია

• თუ საქონელი ნაკლის მქონე აღმოჩნდა, მომხმარებელს უფლება აქვს, მოვაჭრეს მოსთხოვოს ნაკლის აღმოფხვრა (საქონლის უსასყიდლოდ შეკეთება ან შეცვლა, ფასის შემცირება) ან გავიდეს ხელშეკრულებიდან.

• საქონლის შეკეთება და შეცვლა მომხმარებლის პირველი რიგის უფლებებია. მომხმარებელს უფლება აქვს, მოვაჭრეს მოსთხოვოს საქონლის უსასყიდლოდ შეკეთება ან შეცვლა, გარდა იმ შემთხვევისა, როდესაც ეს, საქონლის ბუნებიდან გამომდინარე, შეუძლებელია ან არათანაზომიერ ან შეუსაბამოდ დიდ ხარჯს მოითხოვს.

• საქონელი შეკეთებული ან შეცვლილი უნდა იქნეს გონივრულ ვადაში,ნივთის შეკეთების ვადა 30 დღე, ნივთის შეცვლის ვადა 10 დღე. ისე, რომ მომხმარებელს არ შეექმნას მნიშვნელოვანი შეფერხება საქონლის ბუნებისა და იმ მიზნის გათვალისწინებით, რომლისთვისაც მან ეს საქონელი შეიძინა.

• საქონლის უსასყიდლოდ შეკეთება ან შეცვლა გულისხმობს მოვაჭრის მიერ ყველა ხარჯის (მათ შორის, ფოსტის, სამუშაო ძალისა და მასალების ხარჯების) გაწევას, რომლებიც საჭიროა საქონლის ხელშეკრულებით გათვალისწინებულ პირობებთან შესაბამისობის უზრუნველსაყოფად.

• მომხმარებელს უფლება აქვს, მოითხოვოს საქონლის ფასის შემცირება ან უარი თქვას ხელშეკრულებაზე, თუ არსებობს ერთ-ერთი შემდეგი პირობა:

ა) საქონლის შეკეთება ან შეცვლა შეუძლებელია;

ბ) მოვაჭრემ საქონელი გონივრულ ვადაში არ შეაკეთა ან არ შეცვალა და მომხმარებელმა ხელშეკრულების შესრულებისადმი ინტერესი დაკარგა;

გ) მოვაჭრის მიერ საქონლის შეკეთება ან შეცვლა მომხმარებელს მნიშვნელოვან შეფერხებას შეუქმნის.

• მომხმარებელს უფლება აქვს, ხელშეკრულებიდან გასვლის შემთხვევაში მოითხოვოს ხელშეკრულების შეუსრულებლობით მიყენებული ზიანის ანაზღაურება საქართველოს კანონმდებლობით დადგენილი წესით.

• მომხმარებელს არ აქვს უფლება, უარი თქვას ხელშეკრულებაზე, თუ საქონლის ნაკლი უმნიშვნელოა.

• იმის განსაზღვრისას, თუ რამდენად არათანაზომიერია ან შეუსაბამოდ დიდია ხარჯი, გათვალისწინებული იქნება შემდეგი პირობები:

ა) საქონლის ან მომსახურების ფასი მისი ხელშეკრულებით გათვალისწინებულ პირობებთან შესაბამისობის შემთხვევაში;

ბ) საქონლის ან მომსახურების ხელშეკრულებით გათვალისწინებულ პირობებთან შეუსაბამობის ხარისხი;

გ) საქონლის ნაკლის მომხმარებლისთვის შეფერხების შექმნის გარეშე აღმოფხვრის ალტერნატიული შესაძლებლობა.

• მომხმარებელს უფლება აქვს, ისარგებლოს ზემოხსენებული უფლებებით, თუ საქონლის ნაკლი საქონლის მისთვის გადაცემიდან 2 წლის განმავლობაში აღმოჩნდა.

• თუ მომხმარებელმა საქონლის ნაკლი საქონლის მფლობელობაში მიღებიდან 6 თვის განმავლობაში აღმოაჩინა, საწინააღმდეგოს დამტკიცებამდე იგულისხმება, რომ ნაკლი არსებობდა საქონლის მიწოდებისას, თუ, საქონლის ბუნებიდან ან ნაკლის ხასიათიდან გამომდინარე, ეს შესაძლებელია. ამ შემთხვევაში მტკიცების ტვირთი მოვაჭრეს ეკისრება. თუ მომხმარებელმა საქონლის ნაკლი საქონლის მფლობელობაში მიღებიდან 6 თვის შემდეგ აღმოაჩინა, იმის მტკიცების ტვირთი, რომ ნაკლი არსებობდა საქონლის მიწოდებისას, მომხმარებელს ეკისრება.

5. ფორს–მაჟორი

• არც ერთი მხარე არ აგებს პასუხს ნაკისრი ვალდებულების მთლიანად ან ნაწილობრივ შეუსრულებლობისთვის, თუ შეუსრულებლობა გამოწვეულია სტიქიური და ტექნოლოგიური კატასტროფებით, ხანძრით, საომარი მოქმედებით, სამთავრობო გადაწყვეტილებებით, ეს მოვლენები დაიწყო ან განვითარდა შეკვეთის შეძენის შემდეგ.

• თუ ჩამოთვლილი გარემოებებიდან უშუალოდ რომელიმე მოქმედებს მხარის მიერ ნაკისრი ვალდებულებების წინამდებარე სამომხმარებლო წესებისა და პირობებით განსაზღვრული შესრულების ვადაზე, ეს ვადა გაგრძელდება დაუძლეველი ძალის გარემოების მოქმედების ხანგრძლივობის შესაბამისად.

• მხარე, რომელსაც წამოეჭრა დაუძლეველი ძალის გარემოება, ვალდებულია ასეთი გარემოების, მისი შესაძლო ხანგრძლივობისა და შეწყვეტის შესახებ შეატყობინოს მეორე მხარეს.

• შეტყობინებაში ასახული ფაქტები დადასტურებული უნდა იყოს შესაბამისი რეგიონის: სავაჭრო, სამრეწველო, ან სხვა კომპეტენტური ორგანოს მიერ.

• არშეტყობინება ან დაგვიანებით შეტყობინება უფლებას ართმევს მხარეს, გამოიყენოს ზემოთ მოყვანილი დაუძლეველი ძალის მოვლენები პასუხისმგებლობისგან განთავისუფლების საფუძვლად.`,
};

const infoPages = {
  about: {
    title: 'ABOUT US',
    sections: [
      {
        paragraphs: [
          'At Sifrifana, we believe that the right gift has the power to make someone\'s day brighter. Based in Tbilisi, Georgia, our mission is simple: to help people easily find high-quality, meaningful gifts for their partners, friends, family, or kids - without stress, confusion, or high prices.',
        ],
      },
      {
        heading: 'Our Purpose',
        paragraphs: [
          'Sifrifana exists to bring affordability, quality, and happiness together in one place. Every product we select is chosen with one goal in mind: make gifting joyful, effortless, and personal.',
        ],
      },
      {
        heading: 'What Makes Us Different',
        paragraphs: [
          'We\'re not just a store - we\'re a team focused entirely on gifts that people genuinely love.',
          'Here\'s what sets Sifrifana apart:',
        ],
        list: [
          'Curated gift categories - watches, eyewear, eyeglasses, perfume, knives, presents and more',
          'Unique items you won\'t find everywhere',
          'Fair and honest pricing',
          'Signature packaging designed to impress',
          'A friendly, energetic shopping experience',
        ],
      },
      {
        heading: 'How We Want You to Feel',
        paragraphs: [
          'Shopping at Sifrifana should feel warm, friendly, and fun - like picking gifts with someone who understands what you\'re looking for. No overwhelming menus, no complicated pages - just smooth navigation and products you can trust.',
        ],
      },
    ],
  },
  privacy: {
    title: 'PRIVACY POLICY',
    sections: [
      {
        paragraphs: [
          'The final Privacy Policy text will be added here once it is provided.',
        ],
      },
    ],
  },
  contact: {
    title: 'CONTACT',
    sections: [
      {
        paragraphs: [
          'Address: J. Shartava St. 44',
          'Phone: +995 558 27 22 14',
          'Email: infosifrifana@gmail.com',
        ],
      },
    ],
  },
  payments: {
    title: 'PAYMENTS',
    sections: [
      {
        paragraphs: [
          'Payment information will be updated here soon.',
        ],
      },
    ],
  },
  warranty: {
    title: 'WARRANTY',
    sections: [
      {
        paragraphs: [
          'Warranty information will be updated here soon.',
        ],
      },
    ],
  },
  delivery: {
    title: 'DELIVERY',
    sections: [
      {
        paragraphs: [
          'Delivery information will be updated here soon.',
        ],
      },
    ],
  },
  terms: {
    title: 'TERMS AND CONDITIONS',
    termsTitle: {
      en: 'TERMS AND CONDITIONS',
      ka: 'წესები და პირობები',
    },
  },
  faq: {
    title: 'FAQ',
    sections: [
      {
        paragraphs: [
          'Frequently asked questions will be updated here soon.',
        ],
      },
    ],
  },
};

const infoNavItems = [
  { key: 'about', label: 'ABOUT US', to: '/about-us' },
  { key: 'privacy', label: 'PRIVACY', to: '/privacy-policy' },
  { key: 'contact', label: 'CONTACT', to: '/contact' },
  { key: 'payments', label: 'PAYMENTS', to: '/payments' },
  { key: 'warranty', label: 'WARRANTY', to: '/warranty' },
  { key: 'delivery', label: 'DELIVERY', to: '/delivery' },
  { key: 'terms', label: 'TERMS AND CONDITIONS', to: '/terms-and-conditions' },
  { key: 'faq', label: 'FAQ', to: '/faq' },
];

const infoNavLabelsKa = {
  about: 'ჩვენ შესახებ',
  privacy: 'კონფიდენციალურობა',
  contact: 'კონტაქტი',
  payments: 'გადახდა',
  warranty: 'გარანტია',
  delivery: 'მიწოდება',
  terms: 'წესები და პირობები',
  faq: 'ხშირი კითხვები',
};

const georgianInfoPages = {
  about: {
    title: 'ჩვენ შესახებ',
    sections: [
      {
        paragraphs: [
          'სიფრიფანა 2019 წლიდან დაიწყო — ერთი Facebook გვერდით, ქართული სახელით და იდეით, შეგვექმნა სივრცე, სადაც ადამიანები მარტივად იპოვიდნენ საჩუქრებსა და აქსესუარებს.',
          'ჩვენმა სახელმა და მიდგომამ მალევე მიიქცია ყურადღება. მომხმარებლებმა შეიყვარეს სიფრიფანა როგორც ადგილი, სადაც შესაძლებელია საინტერესო, განსხვავებული და ბიუჯეტური ნივთების შერჩევა.',
          'დღეს სიფრიფანა ერთ-ერთი ყველაზე დიდი ონლაინ მაღაზიაა აქსესუარების მიმართულებით საქართველოში. ონლაინ სივრცესთან ერთად, უკვე გვაქვს 2 ფიზიკური მაღაზია თბილისში, სადაც მომხმარებლებს შეუძლიათ პროდუქციის ადგილზე ნახვა, მორგება და შეძენა.',
          'ჩვენი ასორტიმენტი მოიცავს სათვალეებს, საათებს, სუნამოებს, სამკაულებს და სხვადასხვა სასაჩუქრე ნივთს. ვცდილობთ, მუდმივად განვაახლოთ არჩევანი, რათა მომხმარებელმა ყოველთვის იპოვოს მისთვის სასურველი პროდუქტი მისაღებ ფასად.',
          'ჩვენი მთავარი მიზანია შევქმნათ სივრცე, სადაც ხარისხიანი მომსახურება, სასიამოვნო გამოცდილება და ბიუჯეტური ფასები ერთმანეთს ერწყმის. გვჯერა, რომ ხელმისაწვდომი ფასი არ უნდა ნიშნავდეს დაბალ მომსახურებას — სწორედ ამიტომ ყოველდღიურად ვმუშაობთ იმისთვის, რომ თითოეულ მომხმარებელს შევთავაზოთ ყურადღებიანი, სწრაფი და კომფორტული მომსახურება.',
          'სიფრიფანა აგრძელებს განვითარებას — ვზრდით ასორტიმენტს, ვაუმჯობესებთ ონლაინ მომსახურებას და ვნერგავთ ახალ შესაძლებლობებს, რათა სასურველი პროდუქტის შერჩევა და შეძენა კიდევ უფრო მარტივი და მოსახერხებელი იყოს.',
          'დღეს ჩვენთვის ყველაზე დიდი მოტივაცია ათასობით კმაყოფილი მომხმარებლის ნდობაა. სწორედ ეს ნდობა გვაძლევს ძალას, ყოველდღიურად გავხდეთ უკეთესები და შევქმნათ ისეთი გარემო, სადაც თითოეული სტუმარი თავს დაფასებულად და განსაკუთრებულად იგრძნობს.',
          'მადლობა, რომ ხართ სიფრიფანას ისტორიის ნაწილი. საუკეთესო ჯერ კიდევ წინ არის. 💜',
        ],
      },
    ],
  },
  privacy: {
    title: 'კონფიდენციალურობის პოლიტიკა',
    sections: [
      {
        paragraphs: [
          'სიფრიფანა პატივს სცემს მომხმარებლების პირად ინფორმაციას და ზრუნავს მის უსაფრთხოებაზე.',
        ],
      },
      {
        heading: 'რა ინფორმაციას ვაგროვებთ',
        paragraphs: [
          'შეკვეთის გაფორმებისას ან ჩვენთან დაკავშირებისას შესაძლოა შევაგროვოთ შემდეგი ინფორმაცია:',
        ],
        list: [
          'სახელი და გვარი',
          'ტელეფონის ნომერი',
          'ელ. ფოსტის მისამართი (არსებობის შემთხვევაში)',
          'მიწოდების მისამართი',
          'შეკვეთასთან დაკავშირებული სხვა ინფორმაცია',
        ],
      },
      {
        heading: 'ინფორმაციის გამოყენება',
        paragraphs: [
          'მიღებული ინფორმაცია გამოიყენება:',
        ],
        list: [
          'შეკვეთების დამუშავებისა და მიწოდებისთვის',
          'მომხმარებელთან კომუნიკაციისთვის',
          'მომსახურების ხარისხის გასაუმჯობესებლად',
          'საგარანტიო და შემდგომი მომსახურების უზრუნველსაყოფად',
        ],
      },
      {
        heading: 'ინფორმაციის დაცვა',
        paragraphs: [
          'სიფრიფანა იღებს ყველა გონივრულ ზომას მომხმარებლის მონაცემების უსაფრთხოების დასაცავად. თქვენი პერსონალური ინფორმაცია არ გადაეცემა მესამე პირებს, გარდა იმ შემთხვევებისა, როდესაც ეს აუცილებელია შეკვეთის მიწოდების ან კანონით გათვალისწინებული მოთხოვნების შესასრულებლად.',
        ],
      },
      {
        heading: 'ქუქი-ფაილები (Cookies)',
        paragraphs: [
          'საიტმა შესაძლოა გამოიყენოს ქუქი-ფაილები მომხმარებლის გამოცდილების გასაუმჯობესებლად და საიტის გამართული მუშაობისთვის.',
        ],
      },
      {
        heading: 'მომხმარებლის უფლებები',
        paragraphs: [
          'მომხმარებელს უფლება აქვს მოითხოვოს:',
        ],
        list: [
          'საკუთარი მონაცემების გაცნობა',
          'მონაცემების შესწორება',
          'მონაცემების წაშლა, თუ ამის სამართლებრივი საფუძველი არსებობს',
        ],
      },
      {
        heading: 'საკონტაქტო ინფორმაცია',
        paragraphs: [
          'კონფიდენციალურობის პოლიტიკასთან დაკავშირებული კითხვების შემთხვევაში დაგვიკავშირდით:',
          '📧 info@sifrifana.ge',
        ],
      },
    ],
  },
  contact: {
    title: 'კონტაქტი',
    sections: [
      {
        paragraphs: [
          'ჩვენთვის მნიშვნელოვანია თითოეული მომხმარებელი. თუ გაქვთ შეკითხვა პროდუქციასთან, შეკვეთასთან, მიწოდებასთან, გარანტიასთან ან სხვა ნებისმიერ საკითხთან დაკავშირებით, დაგვიკავშირდით თქვენთვის სასურველი გზით და სიამოვნებით დაგეხმარებით.',
        ],
      },
      {
        heading: 'ელ. ფოსტა',
        paragraphs: [
          '📧 ზოგადი ინფორმაცია და თანამშრომლობა — info@sifrifana.ge',
          '📧 მომხმარებელთა მხარდაჭერა და შეკვეთები — support@sifrifana.ge',
        ],
      },
      {
        heading: 'ჩვენი მისამართები',
        paragraphs: [
          '🏪 ვაზისუბნის ფილიალი — თბილისი, დ. კვაჭანტირაძის 30',
          '🏪 საბურთალოს ფილიალი — თბილისი, შარტავას 44',
        ],
      },
      {
        heading: 'სამუშაო საათები',
        paragraphs: [
          '🕒 ყოველდღე: 11:00 – 21:00',
        ],
      },
      {
        heading: 'სოციალური ქსელები',
        paragraphs: [
          '📱 Facebook — Sifrifanageorgia',
          '📱 Instagram — @sifrifana.ge',
          '📱 TikTok — @sifrifanagifts',
          'ჩვენი გუნდი ყოველდღიურად ზრუნავს, რომ მიიღოთ სწრაფი, კომფორტული და ხარისხიანი მომსახურება. თქვენი კმაყოფილება ჩვენთვის ყველაზე მნიშვნელოვანია.',
        ],
      },
    ],
  },
  payments: {
    title: 'გადახდა',
    sections: [
      {
        paragraphs: [
          'სიფრიფანა მომხმარებლებს სთავაზობს გადახდის რამდენიმე კომფორტულ მეთოდს, რათა სასურველი პროდუქტის შეძენა მაქსიმალურად მარტივი იყოს.',
        ],
      },
      {
        heading: 'ონლაინ გადახდა',
        paragraphs: [
          'საიტზე შეკვეთის გაფორმებისას შეგიძლიათ ისარგებლოთ:',
        ],
        list: [
          'საბანკო ბარათით გადახდით',
          'ინტერნეტ ბანკის საშუალებით გადახდით',
          'სხვადასხვა ბანკის მიერ შემოთავაზებული ონლაინ გადახდის მეთოდებით',
          'ონლაინ განვადებით (შესაბამის პროდუქტებზე და ბანკების პირობების მიხედვით)',
        ],
      },
      {
        heading: 'ფიზიკურ მაღაზიებში გადახდა',
        paragraphs: [
          'ჩვენს ფილიალებში გადახდა შესაძლებელია:',
        ],
        list: [
          'ნაღდი ანგარიშსწორებით',
          'საბანკო ბარათით',
          'POS ტერმინალის საშუალებით',
        ],
      },
      {
        heading: 'უსაფრთხოება',
        paragraphs: [
          'ყველა გადახდა ხორციელდება დაცული სისტემების გამოყენებით და მოქმედი კანონმდებლობის შესაბამისად, რათა თქვენი ფინანსური მონაცემები იყოს უსაფრთხოდ დაცული.',
          'თუ გადახდასთან დაკავშირებით დამატებითი ინფორმაცია გჭირდებათ, დაგვიკავშირდით:',
          '📧 support@sifrifana.ge',
          '📧 info@sifrifana.ge',
        ],
      },
    ],
  },
  warranty: {
    title: 'გარანტია',
    sections: [
      {
        paragraphs: [
          'სიფრიფანაში მომხმარებლის კმაყოფილება და უფლებების დაცვა ჩვენთვის უმნიშვნელოვანესია.',
          'ყველა მომხმარებელი სარგებლობს საქართველოს მოქმედი კანონმდებლობით გათვალისწინებული უფლებებით. პროდუქციის შეძენის შემთხვევაში, ნებისმიერი საკითხი განიხილება ინდივიდუალურად და სამართლიანად, მოქმედი წესებისა და პირობების შესაბამისად.',
          'თუ პროდუქტის მიღებისას აღმოაჩენთ ქარხნულ დეფექტს ან პროდუქტი არ შეესაბამება შეკვეთილ ნივთს, გთხოვთ დაგვიკავშირდეთ უმოკლეს ვადაში. ჩვენი გუნდი შეისწავლის საკითხს და შემოგთავაზებთ შესაბამის გადაწყვეტას.',
          'საათების გარკვეულ მოდელებზე მოქმედებს დამატებითი გარანტია, რომლის პირობებიც მითითებულია პროდუქტის აღწერაში ან გაცნობებთ შეძენის დროს.',
          'გარანტია არ ვრცელდება პროდუქტის არასწორი გამოყენებით, მექანიკური დაზიანებით, დაუდევრობით ან ბუნებრივი ცვეთის შედეგად გამოწვეულ დაზიანებებზე.',
          'დამატებითი ინფორმაციისთვის დაგვიკავშირდით:',
          '📧 support@sifrifana.ge',
          '📧 info@sifrifana.ge',
          'სიფრიფანა ყოველთვის მზად არის, მომხმარებლის ინტერესები დაიცვას და ნებისმიერი საკითხი მაქსიმალურად სწრაფად და სამართლიანად გადაწყვიტოს.',
        ],
      },
    ],
  },
  delivery: {
    title: 'მიწოდება',
    sections: [
      {
        paragraphs: [
          'სიფრიფანა ახორციელებს შეკვეთების მიწოდებას საქართველოს მასშტაბით.',
          'შეკვეთის გაფორმებისა და დადასტურების შემდეგ, ჩვენი გუნდი მაქსიმალურად სწრაფად ამუშავებს შეკვეთას და გადასცემს საკურიერო სამსახურს.',
        ],
      },
      {
        heading: 'მიწოდების ტარიფები',
        paragraphs: [
          'თბილისის მასშტაბით მიწოდების ღირებულება შეადგენს 6 ლარს.',
          'რეგიონებში მიწოდების ღირებულება შეადგენს 9 ლარს.',
          'მიწოდების ღირებულების შესახებ მომხმარებელი წინასწარ იქნება ინფორმირებული შეკვეთის გაფორმებისას ან დადასტურების პროცესში.',
        ],
      },
      {
        heading: 'მიწოდების პირობები',
        paragraphs: [
          'მიწოდება ხორციელდება საქართველოს მთელ ტერიტორიაზე.',
          'შეკვეთის დამუშავებისა და მიწოდების ვადები დამოკიდებულია ადგილმდებარეობასა და საკურიერო მომსახურების პირობებზე.',
          'განსაკუთრებულ შემთხვევებში მიწოდების ვადა შესაძლოა შეიცვალოს, რის შესახებაც მომხმარებელს წინასწარ ეცნობება.',
        ],
      },
      {
        heading: 'შეკვეთის მიღება',
        paragraphs: [
          'პროდუქტის მიღებისას გთხოვთ შეამოწმოთ შეკვეთის სისწორე და პროდუქტის მდგომარეობა. თუ აღმოაჩენთ რაიმე ხარვეზს, გთხოვთ დაუყოვნებლივ დაგვიკავშირდეთ.',
          'დამატებითი კითხვების შემთხვევაში დაგვიკავშირდით:',
          '📧 support@sifrifana.ge',
          '📧 info@sifrifana.ge',
          'სიფრიფანას მიზანია, თქვენი შეკვეთა უსაფრთხოდ, სწრაფად და კომფორტულად მოგაწოდოთ საქართველოს ნებისმიერ წერტილში.',
        ],
      },
    ],
  },
  terms: {
    title: 'წესები და პირობები',
  },
  faq: {
    title: 'ხშირი კითხვები',
    sections: [
      {
        paragraphs: [
          'ხშირად დასმული კითხვები მალე განახლდება.',
        ],
      },
    ],
  },
};

const getPageKeyFromPath = (pathname) => {
  switch (pathname) {
    case '/privacy-policy':
      return 'privacy';
    case '/contact':
      return 'contact';
    case '/payments':
      return 'payments';
    case '/warranty':
      return 'warranty';
    case '/delivery':
      return 'delivery';
    case '/terms-and-conditions':
      return 'terms';
    case '/faq':
      return 'faq';
    case '/about-us':
    default:
      return 'about';
  }
};

const InfoPage = () => {
  const location = useLocation();
  const { language } = useLanguage();
  const pageKey = getPageKeyFromPath(location.pathname);
  const page = infoPages[pageKey] || infoPages.about;
  const localizedPage = language === 'ka' ? georgianInfoPages[pageKey] : null;
  const isTermsPage = pageKey === 'terms';
  const title = localizedPage?.title || (isTermsPage ? page.termsTitle[language] || page.termsTitle.en : page.title);
  const termsText = termsBody[language] || termsBody.en;
  const sections = localizedPage?.sections || page.sections || [];

  return (
    <div className="info-page">
      <div className="info-page__layout">
        <aside className="info-page__sidebar" aria-label={language === 'ka' ? 'საინფორმაციო გვერდები' : 'Information pages'}>
          <nav className="info-page__nav">
            {infoNavItems.map((item) => (
              <Link
                key={item.key}
                to={item.to}
                className={`info-page__nav-link ${item.key === pageKey ? 'is-active' : ''}`}
              >
                {language === 'ka' ? infoNavLabelsKa[item.key] || item.label : item.label}
              </Link>
            ))}
          </nav>
        </aside>

        <article className="info-page__card">
          <h1>{title}</h1>

          {isTermsPage ? (
            <div className="info-page__legal-text">{termsText}</div>
          ) : (
            sections.map((section, index) => (
              <section key={`${section.heading || 'intro'}-${index}`} className="info-page__section">
                {section.heading && <h2>{section.heading}</h2>}
                {section.paragraphs?.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
                {section.list && (
                  <ul>
                    {section.list.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                )}
              </section>
            ))
          )}
        </article>
      </div>
    </div>
  );
};

export default InfoPage;
